import { Form } from "react-bootstrap";
import { FormTypeField } from "../utils/formTypeField";

const FormField = ({
  label,
  showLabel = true,
  formControlType,
  register,
  validationError,
  min,
  step,
}) => {
  return (
    <Form.Group controlId={label} className="mb-2 mt-3">
      {formControlType === "checkbox" ? (
        <div className="d-flex align-items-center gap-2">
          <FormTypeField
            formControlType={formControlType}
            register={register}
          />
          <Form.Label className="mb-0">{label}</Form.Label>
        </div>
      ) : (
        <>
          {showLabel && <Form.Label>{label}</Form.Label>}
          <FormTypeField
            formControlType={formControlType}
            register={register}
            min={min}
            step={step}
          />
        </>
      )}

      {validationError && <div className="text-danger">{validationError}</div>}
    </Form.Group>
  );
};

export default FormField;
